import script from "./OkrBreadcrumbs.vue?vue&type=script&setup=true&lang=js"
export * from "./OkrBreadcrumbs.vue?vue&type=script&setup=true&lang=js"

import "./OkrBreadcrumbs.vue?vue&type=style&index=0&id=30ed262f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30ed262f"]])

export default __exports__